//import classes
import { outlinedInputClasses } from "@mui/material/OutlinedInput";
import { SINGLE } from "../../../constants/numbers.consts.js";
const MUI_FOCUSED_CLASS = "Mui-focused";
export default {
    styleOverrides: {
        root: ({ theme }) => ({
            [`& .${outlinedInputClasses.notchedOutline}`]: {
                borderRadius: theme.spacing(SINGLE),
            },
            [`&:hover .${outlinedInputClasses.notchedOutline}`]: {
                borderRadius: theme.spacing(SINGLE),
            },
            [`&.${MUI_FOCUSED_CLASS} .${outlinedInputClasses.notchedOutline}`]: {
                borderRadius: theme.spacing(SINGLE),
            },
        }),
    },
};
